exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding-20p[data-v-cfb97cc2] { padding: 20%;\n}\n.checkbox-skinny[data-v-cfb97cc2]{ margin: 70% 0px 0px 40%\n}\n.checkbox-border[data-v-cfb97cc2]{ border: 1px solid #cccccc; border-radius: 4px; height: 34px;\n}\n", ""]);

// exports
